import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from './ui/card';
import { Button } from './ui/button';
import { X } from '@phosphor-icons/react';

function CreditModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-in fade-in duration-200">
      <Card className="max-w-sm w-full shadow-2xl">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-xl font-bold flex items-center gap-2">
            👦🏻 Credit
          </CardTitle>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8 rounded-full">
            <X size={20} />
          </Button>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-gray-600">
          <div className="p-3 bg-gray-50 rounded-lg space-y-2">
            <p>
              <strong className="text-gray-900">*앱 정보:</strong> VIVA FLIP
            </p>
            <p>
              <strong className="text-gray-900">*만든이:</strong> 라이프오브파이 & VIVASAM
            </p>
            <p>
              <strong className="text-gray-900">*아이디어:</strong> 윤신영 선생님
            </p>
          </div>
          <p className="text-center italic text-gray-500 pt-2">
            *커피와 무료함을 좋아합니다
          </p>
          <p className="text-center font-medium text-primary">
            Thanks to T.R.I.P.O.D. 교과연구회
          </p>
        </CardContent>
        <CardFooter>
          <Button onClick={onClose} className="w-full">
            닫기
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}

export default CreditModal;